import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './styles/tokens.css'
import '@phosphor-icons/web/regular'
import '@phosphor-icons/web/fill'
import { installImageBedObserver } from './utils/imagebed'
import { showAlert, showConfirm } from './utils/dialog'
import { initTranslate } from './utils/translate'
import { useUserStore } from './store/user'
import { useAdminStore } from './store/admin'
import { setUnauthorizedHandler, setAdminUnauthorizedHandler } from './api/http'
import { registerServiceWorker } from './utils/pwa'

// 一次性清理旧版列表页 localStorage 缓存（已迁移到进程内内存）：残留无害但占配额，启动时扫除。
;(() => {
  try {
    const legacy = ['crirp_topic_cache:', 'crirp_topic_posts_cache:', 'crirp_home_cache']
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i)
      if (key && legacy.some((p) => key.startsWith(p))) localStorage.removeItem(key)
    }
  } catch (e) { /* 隐私模式 / 不可用：忽略 */ }
})()

const app = createApp(App)
app.use(createPinia())
app.use(router)

// 全局 401：用户接口登录失效 → 清用户 session（不发请求，避免递归）
setUnauthorizedHandler(() => useUserStore().clearSession())
// 后台接口未授权 → 仅清后台态，绝不波及用户登录态（admin / user 各自独立）
setAdminUnauthorizedHandler(() => useAdminStore().clear())

// 全局弹窗：组件内用 this.$alert / this.$confirm，任意 JS 用 window.$alert / window.$confirm
app.config.globalProperties.$alert = showAlert
app.config.globalProperties.$confirm = showConfirm
if (typeof window !== 'undefined') {
  window.$alert = showAlert
  window.$confirm = showConfirm
}

app.mount('#app')

// PWA：注册 service worker（安全上下文），失败静默
registerServiceWorker()

installImageBedObserver()
// 浏览器语言非中文（或带 ?lang=xx 测试参数）时注入 Google 翻译
initTranslate()
